module.exports = __webpack_public_path__ + "assets/img/DownloadFile@2x.0f8ddec4.png";